import { Store } from '../Store';
import { LehrerEnv } from '../../../env/LehrerEnv';
import { memoize } from '../../../utils/mobx/decorators/memoize';
import { RequestStoreHost } from './RequestStoreHost';
import { RequestStoreLocation } from './RequestStoreLocation';

export class RequestStore {
  readonly store: Store;

  constructor(store) {
    this.store = store;
  }

  get requestData() {
    return this.store.storeData.requestData;
  }

  @memoize
  get requestHost() {
    return new RequestStoreHost(this);
  }

  @memoize
  get requestLocation() {
    return new RequestStoreLocation(this);
  }

  get isDevelopmentStage(): boolean {
    return this.requestData.subdomain === 'dev';
  }
}
